import script from "./LessonsFoot.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonsFoot.vue?vue&type=script&setup=true&lang=js"

import "./LessonsFoot.vue?vue&type=style&index=0&id=fb07a106&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb07a106"]])

export default __exports__